import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    itemsOnly: {},
    panel: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(3),
        flexWrap: 'wrap',
        width: '100%',
        minHeight: 72,
        borderRadius: theme.radius,
        border: `1.5px solid ${theme.colors.grey_light}`,
        backgroundColor: theme.colors.white,
        padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
        [theme.down('desktop')]: {
            padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
        },
        [theme.down('mobile')]: {
            padding: `${theme.spacing(2)} ${theme.spacing(2)}`,
        },
    },
    left: {
        display: 'flex',
        alignItems: 'center',
        minWidth: 0,
        flex: '1 1 220px',
    },
    iconWrapper: {
        display: 'flex',
    },
    icon: {
        marginLeft: theme.spacing(3),
        color: theme.colors.violet_primary,
        cursor: 'pointer',
        fontSize: 24,
    },
    title: {
        fontFamily: theme.font.secondary,
        fontSize: 24,
        lineHeight: 1.33,
        color: theme.colors.black,
        fontWeight: 'normal',
    },
    items: {
        display: 'flex',
        width: '60%',
        justifyContent: 'flex-end',
        gap: theme.spacing(3),
        '&$itemsOnly': {
            width: '100%',
            justifyContent: 'space-between',
        },
        [theme.down('desktop')]: {
            width: '100%',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: theme.spacing(2),
        },
        [theme.down('mobile')]: {
            gap: theme.spacing(1.5),
        },
    },
    item: {
        display: 'flex',
        width: '33.33%',
        alignItems: 'center',
        minWidth: 150,
        '$itemsOnly &': {
            flex: '1 1 0',
            width: 'auto',
            minWidth: '12rem',
        },
        [theme.down('desktop')]: {
            width: 'calc(50% - 12px)',
        },
        [theme.down('mobile')]: {
            width: '100%',
            minWidth: 0,
        },
    },
    info: {
        paddingLeft: theme.spacing(3),
        minWidth: 0,
    },
    itemTitle: {
        fontFamily: theme.font.secondary,
        fontSize: 14,
        lineHeight: 1.25,
        color: theme.colors.grey_text,
    },
    text: {
        fontFamily: theme.font.primary,
        color: theme.colors.violet_primary,
        fontSize: 18,
        fontWeight: 'normal',
        lineHeight: 1.4,
    },
}));
